import { Directive, ElementRef, Input, Renderer, SimpleChanges, OnChanges } from '@angular/core';

@Directive({
  selector: '[appColorBoton]'
}) 
export class ColorBotonDirective implements OnChanges {

  constructor(private _element:ElementRef, private _renderer:Renderer) {}

  @Input()appColorBoton: string

  ngOnChanges(){
    switch(this.appColorBoton) {
      case "0":
        this._renderer.setElementClass(this._element.nativeElement, 'primary', true);
        break;
      case "1":
        this._renderer.setElementClass(this._element.nativeElement, 'warn-600', true);
        break;
      case "2":
        this._renderer.setElementClass(this._element.nativeElement, 'yellow-600', true);
        break;
      case "3":
        this._renderer.setElementClass(this._element.nativeElement, 'accent-500', true);
        break;
      case "4":
        this._renderer.setElementClass(this._element.nativeElement, 'pink-A200', true);
        break;
      case "10":
        this._renderer.setElementClass(this._element.nativeElement, 'primary-50', true);
        break;
      default:
        this._renderer.setElementClass(this._element.nativeElement, 'primary', true);
        break;
    }
  }
}

